export const pagination = {
    slots: {
        item: 'text-neutral-700 font-normal data-[selected=true]:bg-blue-100',
    },
}
